"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;
var _Icon = require("../Icon/Icon");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _formsModule = _interopRequireDefault(require("@albelli/arc-3/lib/forms.module.css"));
var _dropdownModule = _interopRequireDefault(require("@albelli/arc-3/lib/dropdown.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Dropdown = _ref => {
  let {
    children,
    value,
    onChange,
    label,
    isRequired,
    id,
    className,
    borderless,
    error,
    disabled,
    ...props
  } = _ref;
  const classes = (0, _classnames.default)(_dropdownModule.default["arc3-select-dropdown"], {
    [_dropdownModule.default["--no-border"]]: borderless,
    [_dropdownModule.default["error"]]: error,
    [_dropdownModule.default["disabled"]]: disabled
  }, "arc3-full-width");
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    "data-cy": "arc3-dropdown"
  }, !!label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: _formsModule.default["arc3-form-label"]
  }, label, isRequired ? " *" : null), /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, /*#__PURE__*/_react.default.createElement("select", _extends({
    id: id,
    value: value,
    onChange: onChange,
    disabled: disabled
  }, props, {
    className: "arc3-full-width"
  }), children), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: "arrow_right",
    size: "extra-small",
    className: _dropdownModule.default["arc3-dropdown__icon"]
  }), !!error && /*#__PURE__*/_react.default.createElement("small", {
    className: _dropdownModule.default["arc3-select-dropdown-message"]
  }, /*#__PURE__*/_react.default.createElement("span", null, error))));
};
exports.Dropdown = Dropdown;